import React, { useEffect,useState } from 'react';
import { useParams } from 'react-router-dom';
import { getToken,decodeToken } from '../../utils/TokenUtils';
import { API_URL, ENDPOINTS } from '../../constants/api';
import axios from 'axios';
import { notification } from 'antd';

const PosInvoiceJazira = () => {
    const [data,setData]=useState([]);

    
  const styles = {
  container: {
    fontFamily: 'Roboto',
    width: '80mm',
    padding: '0',
    margin: '0',
    fontSize: '16px',
    fontWeight: '700', // stronger bold
    background: 'white',
    color: 'black',
  },

  center: {
    textAlign: 'center',
    marginBottom: '6px',
    fontWeight: '700',
  },

  divider: {
    borderTop: '1px dashed #000',
    margin: '4px 0',
  },

  table: {
    width: '100%',
    borderCollapse: 'collapse',
    border: '1px solid black',
    fontWeight: '700', // force bold in table
  },

  thtd: {
    fontWeight: '700', // make sure cells are bold
    textAlign: 'left',
    padding: '2px',
    border: '1px solid black',
  },

  headerGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '2px',
    marginBottom: '6px',
    fontWeight: '700',
  },

  rightText: {
    textAlign: 'right',
    margin: '0 0 4px 0',
    fontWeight: '700',
    color: 'black'
  },
};
const { route, id } = useParams();
     const token = getToken();
    useEffect(() => {
   
    const url = `${API_URL}/${ENDPOINTS.SYS}/activityReport/${route}`;
     console.log('url:', url);
    const posInvoice = async () => {
      try {
        const response = await axios.post(url, {order_id:id},{
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        setData(response.data.data);
         console.log("api res: ",response.data);
        if(response.data.message){
                  notification.error({message: response.data.message})

        }
      } catch (error) {
        notification.error({message: error.message})
        console.error('Error fetching data:', error);
       
      }
    };

    posInvoice();
  }, [route]);
  // Extract sections
  const header = data?.find(d => d.title === 'header')?.fields || {};
  const itemsData = data?.find(d => d.title === 'items');
const items = Array.isArray(itemsData?.table)
  ? itemsData.table
  : itemsData?.fields
  ? [itemsData.fields]
  : [];

  const payment = data?.find(d => d.title === 'payment')?.fields || {};
  const companyName = decodeToken(token, 'companyName');
  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.center}>
        <h3 style={{ margin: 0,fontWeight:"bold" }}>{companyName}</h3>
      </div>

       <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '6px' }}>
  {Object.entries(header).map(([key, value], i) => {
    const [label, col] = key.split('~');
    const width = col ? `${(col / 12) * 100}%` : '50%'; // default col-6
    return (
      <div key={i} style={{ width, padding: '2px 0' }}>
        <strong>{label}:</strong> {value}
      </div>
    );
  })}
</div>

      <div  />

      {/* Items Table */}
      <table style={styles.table}>
        <thead>
          <tr>
            {items.length > 0 &&
              Object.keys(items[0]).map((head, i) => (
                <th key={i} style={styles.thtd}>{head}</th>
              ))}
          </tr>
        </thead>
        <tbody>
          {items.map((row, i) => (
            <tr key={i}>
              {Object.values(row).map((val, j) => (
                <td key={j} style={styles.thtd}>{val}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      <div  />

      {/* Payment summary aligned right */}
      <div>
        {Object.entries(payment).map(([key, value], i) => (
          <p key={i} style={styles.rightText}>
            <strong>{key}:</strong> {value}
          </p>
        ))}
        {payment.total && payment.paid && (
          <p style={styles.rightText}>
            <strong>Change:</strong>{' '}
            {(parseFloat(payment.paid) - parseFloat(payment.total)).toFixed(2)}
          </p>
        )}
      </div>

      {/* Footer */}
      <div style={{ ...styles.center, marginTop: '10px' }}>
        <p style={{ margin: 0 }}>Thanks for your order!</p>
        <p style={{ margin: 0 }}>Powered by KTC</p>
      </div>
    </div>
  );
};

export default PosInvoiceJazira;
